// extracted by mini-css-extract-plugin
export var hideEditor = "_nh-2";
export var infoIcon = "_nh-3";
export var label = "_nh-1";
export var labelContainer = "_nh-0";
export var readonlyText = "_nh-4";